import React, { FC, useCallback, useMemo, useState } from 'react';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import { trackTendersFilterBuyers } from 'src/segment/events';
import CompaniesSearch from 'src/shared/OrgsSearch';
import styles from './index.module.scss';
import { xor } from 'lodash';
import CompaniesList from 'src/shared/MatchingProfile/CompaniesFilter/CompaniesList';

export const FilterOrgs: FC = () => {
  const [{ vars, eventSource }, updateVars] = useApiTenders();
  const ids = useMemo(() => vars.buyerOrgIds ?? [], [vars.buyerOrgIds]);
  const strings = useMemo(() => vars.buyerSearchStrings ?? [], [vars.buyerSearchStrings]);
  const [lastAddedOrgIds, setLastAddedOrgIds] = useState<string[]>([]);

  const onAddOrgs = useCallback(
    (exact?: string[], prefix?: string[]) => {
      if (xor(exact ?? [], ids).length !== 0 || xor(prefix ?? [], strings).length !== 0) {
        const uniqueCompaniesIds = [...new Set([...(exact ?? []), ...ids])];
        const uniqueSearchStrings = [...new Set([...(prefix ?? []), ...strings])];
        exact && setLastAddedOrgIds(() => exact);

        updateVars({ buyerOrgIds: uniqueCompaniesIds, buyerSearchStrings: uniqueSearchStrings });
        trackTendersFilterBuyers(eventSource);
      }
    },
    [eventSource, ids, strings, updateVars]
  );

  const onRemoveOrgs = useCallback(
    (updatingIds, updatingSearchStrings) => {
      updateVars({ buyerOrgIds: updatingIds, buyerSearchStrings: updatingSearchStrings });
    },
    [updateVars]
  );

  return (
    <div className={styles.companiesFilter}>
      <CompaniesSearch exact={ids} prefix={strings} mode={'multiple'} onSelect={onAddOrgs} />
      <div className={styles.companiesList}>
        <CompaniesList
          disabled={false}
          orgNumbers={ids}
          orgSearchStrings={strings}
          lastAddedOrgIds={lastAddedOrgIds}
          removeOrgs={onRemoveOrgs}
        />
      </div>
    </div>
  );
};

export default FilterOrgs;
